<template>
	<ImageViewerDialog :model-value="Boolean(dialogs.imageKey)" :url="url" :loading="loading" @update:model-value="(value) => !value && close()" />
</template>

<script setup>
import { ref, watch } from 'vue';
import { useChromeDialogs } from '@/composables/useChromeDialogs';
import { loadCartLineImage } from '@/iframe/legacyNavActions';
import ImageViewerDialog from '@/components/dialogs/ImageViewerDialog.vue';

const dialogs = useChromeDialogs();

const url = ref(null);
const loading = ref(false);

const release = () => {
	if (url.value?.startsWith('blob:')) URL.revokeObjectURL(url.value);
	url.value = null;
};

watch(
	() => dialogs.imageKey,
	async (key) => {
		release();
		if (!key) return;
		loading.value = true;
		const next = await loadCartLineImage(key);
		loading.value = false;
		if (dialogs.imageKey !== key) {
			if (next?.startsWith('blob:')) URL.revokeObjectURL(next);
			return;
		}
		url.value = next;
	}
);

const close = () => {
	dialogs.imageKey = null;
};
</script>
